export default __webpack_public_path__ + "static/media/twitterIcon.fb22f4b1.svg";